import ItServiceImg from "../assets/itSolution.jpg";
import growthStratergy from "../assets/marketing-stratergy.jpg";
import harsh from "../assets/testimonial-1.jpeg";
import Jason from "../assets/testimonial-2.jpeg";
import abhinav from "../assets/testimonial-3.jpeg";
import Emily from "../assets/tetstimonial-4.jpeg";
import rehmat from "../assets/rhemat.jpg";
import webdevelopment from "../assets/coders.jpg";
import digitalMarketing from "../assets/digital-marketing.jpg";
import marketingReseach from "../assets/market-research.jpg";
import businessStrategyImg from "../assets/business-strategy.jpg";
import appdevelopment from "../assets/appdev.jpg";
const service = [
  {
    slug: "web-development",
    name: "Web Development",
    description:
      "Transform Your Digital Presence with SocioLoom's Web Development Expertise! At SocioLoom, we understand that your website is the virtual storefront of your business, and we're here to ensure it makes a lasting impression. Our web development services are crafted to elevate your online presence, combining creativity, functionality, and the latest technologies.",
    keyHeading1: "Cutting-edge Technology:-",
    keyF_1:
      "Our team of skilled developers harnesses the power of the latest technologies to create websites that are not just visually appealing but also technically robust.",
    keyHeading2: "User-Centric Design:-",
    keyF_2:
      "We prioritize the user experience, ensuring that your website is intuitive, responsive, and tailored to engage your target audience effectively.",
    keyHeading3: "Custom Solutions:-",
    keyF_3:
      "No two businesses are alike, and neither should their websites be. We offer custom web development solutions that align with your unique goals, industry, and brand identity.",
    keyHeading4: "Scalability:-",
    keyF_4:
      "Your website should grow as your business does. Our scalable solutions ensure that your website can adapt to the evolving needs of your business.",
    keyHeading5: "Security First:-",
    keyF_5:
      "We prioritize the security of your website and data. Our development practices include robust security measures to safeguard your online presence.",

    whyTech_1:
      "We believe in providing high-quality web development services without breaking the bank. Our pricing is transparent and tailored to fit the budgets of startups and small businesses.",

    whyTech_2:
      "Your vision is our guide. We work closely with you to understand your goals, preferences, and aspirations, ensuring that the final product reflects your brand identity.",

    bottomDescription:
      "Ready to elevate your online presence? Let SocioLoom be your partner in web development excellence. Contact us today to embark on a digital journey that sets your business apart!",
    image: webdevelopment,
    background: "#E8DAEF",
    getACall: "See More",
  },
  {
    slug: "app-development",
    name: "App Development",
    description:
      "SocioLoom builds powerful, scalable, and user-friendly mobile applications tailored to your business needs. In today’s digital era, a strong mobile presence is essential to connect with your customers and grow efficiently. We specialize in crafting custom Android, iOS, and cross-platform apps using the latest technologies. Whether you're a startup launching an MVP or an enterprise building a business tool, we deliver apps that are fast, secure, and intuitive. From planning to deployment and ongoing support, SocioLoom is your trusted partner in turning innovative ideas into successful mobile applications that make an impact.",

    keyHeading1: "Modern Tech Stack:-",
    keyF_1:
      "We use the latest frameworks and tools like Flutter, React Native, Swift, and Kotlin to deliver fast and reliable apps.",

    keyHeading2: "Intuitive UI/UX:-",
    keyF_2:
      "Our team designs seamless, attractive interfaces that engage users and drive interaction across all screen sizes.",

    keyHeading3: "Custom App Solutions:-",
    keyF_3:
      "Every app is built specifically to meet your business goals, industry standards, and customer expectations.",

    keyHeading4: "Scalability & Performance:-",
    keyF_4:
      "We ensure your app can grow with your business, maintaining speed, reliability, and efficiency as users increase.",

    keyHeading5: "Security First Approach:-",
    keyF_5:
      "Data protection is our top priority — we follow best security practices to keep your app and users safe.",

    keyHeading6: "Cross-Platform Excellence:-",
    keyF_6:
      "We develop cross-platform apps that work smoothly on both Android and iOS, saving you time and cost.",

    whyTech_1:
      "Affordable, transparent pricing ensures quality app development accessible to startups and growing businesses.",

    whyTech_2:
      "We collaborate closely with clients at every step to ensure the final app reflects their vision and needs.",

    bottomDescription:
      "Ready to bring your app idea to life? Partner with SocioLoom for expert mobile app development that drives real results.",

    image: appdevelopment, // Replace with the actual image import or path
    background: "#D6EAF8",
    getACall: "See More",
  },
  {
    slug: "digital-marketing",
    name: "Digital Marketing",
    description:
      "Ignite Your Online Presence with SocioLoom's Digital Marketing Expertise! In the ever-evolving digital landscape, standing out is not just an option, it's a necessity. At SocioLoom, our digital marketing services are tailored to propel your brand to new heights, amplify your reach, and drive meaningful engagement.",
    keyHeading1: "Strategic Planning:-",
    keyF_1:
      "We don't believe in one-size-fits-all solutions. Our digital marketing strategies are crafted after a thorough analysis of your business, industry, and target audience to ensure maximum impact.",
    keyHeading2: "Targeted Campaigns:-",
    keyF_2:
      "Reach the right audience at the right time. Our digital marketing experts design and execute targeted campaigns across various channels to drive relevant traffic and conversions.",
    keyHeading3: "Search Engine Optimisation (SEO):-",
    keyF_3:
      "Boost your visibility on search engines. Our SEO strategies are designed to improve your website's ranking, driving organic traffic and enhancing your online presence.",
    keyHeading4: "Social Media Mastery:-",
    keyF_4:
      "Leverage the power of social media. We create compelling social media campaigns to connect with your audience, build brand loyalty, and drive engagement.",
    keyHeading5: "Content that Converts:-",
    keyF_5:
      "Content is king, and we make sure yours reigns supreme. Our content marketing strategies are geared towards creating valuable, shareable, and conversion-driven content.",

    whyTech_1:
      "We stay ahead of industry trends, ensuring that your digital marketing strategies are not just current but forward-thinking.",
    whyTech_2:
      "We believe that effective digital marketing shouldn't break the bank. Our services are designed to provide maximum impact within your budget constraints.",
    whyTech_3:
      "Your success is our success. We work collaboratively with you, keeping you in the loop at every stage to align our strategies with your business objectives.",
    bottomDescription:
      "Ready to elevate your digital presence? Let SocioLoom be your partner in digital marketing excellence. Contact us today to embark on a journey of digital success!",
    image: digitalMarketing,
    getACall: "See More",
  },
  {
    slug: "growth-strategy",
    name: "Growth Strategy",
    description:
      "Ignite Your Growth Potential with SocioLoom's Strategic Growth Solutions! In today's competitive landscape, achieving sustainable growth requires more than just ambition – it demands a strategic approach. At SocioLoom, we specialize in crafting tailored growth strategies that propel businesses to new heights, unlock untapped opportunities, and drive lasting success.",
    shortDescription:
      "Fuel your business growth with SocioLoom's strategic prowess. We chart a course for success through innovative solutions in web development, digital marketing, and brand building. Our collaborative approach, coupled with affordable yet impactful strategies, ensures that your business not only survives but thrives in the dynamic digital ecosystem. Partner with SocioLoom - Where Growth Meets Strategy.",

    keyHeading1: "Comprehensive Analysis:-",
    keyF_1:
      "One size does not fit all. Our experienced growth strategists conduct in-depth analyses of your market, competitors, customer segments, and internal capabilities to identify strategic growth opportunities specific to your business.",
    keyHeading2: "Innovative Solutions:-",
    keyF_2:
      "Break through barriers with innovation. We believe in thinking outside the box and developing creative solutions that differentiate your business, disrupt the market, and accelerate growth.",
    keyHeading3: "Targeted Expansion:-",
    keyF_3:
      "Expand your horizons strategically. Our growth strategies are designed to help you penetrate new markets, diversify revenue streams, and capitalize on emerging trends, all while minimizing risks and maximizing returns.",
    keyHeading4: "Customer-Centric Approach:-",
    keyF_4:
      "Put your customers first. We leverage customer insights and feedback to inform our growth strategies, ensuring that every initiative is aligned with the needs and preferences of your target audience.",
    keyHeading5: "Scalable Tactics:-",
    keyF_5:
      "Scale your growth efforts effectively. Our strategies are scalable and adaptable, allowing you to ramp up initiatives as your business grows and evolve in response to changing market conditions.",

    image: growthStratergy,
    background: "#D5F5E3",
    getACall: "See More",
  },
  {
    slug: "market-research",
    name: "Market Research",
    description:
      "Empower Your Business with Insightful Market Research from SocioLoom! In today's dynamic business landscape, knowledge is power. At SocioLoom, we specialize in delivering comprehensive market research solutions that provide invaluable insights, inform strategic decision-making, and drive business success.",
    shortDescription:
      "SocioLoom pioneers market research excellence, providing businesses with deep insights to navigate dynamic landscapes. Our comprehensive market research services offer a strategic edge, guiding decisions on web development, digital marketing, and brand building. Stay ahead of trends, understand your audience, and drive success with SocioLoom's data-driven approach. Empower your business with informed choices, choose SocioLoom - Your Gateway to Market Intelligence.",

    keyHeading1: "Thorough Analysis:-",
    keyF_1:
      "Gain a deep understanding of your market landscape. Our experienced market research analysts conduct thorough analyses of industry trends, competitive dynamics, consumer behavior, and emerging opportunities to uncover valuable insights.",
    keyHeading2: "Customized Approach:-",
    keyF_2:
      "No two businesses are alike. We tailor our market research methodologies to suit your specific needs, ensuring that you receive actionable insights that are relevant and impactful for your organization.",
    keyHeading3: "Data-Driven Insights:-",
    keyF_3:
      "Make informed decisions with confidence. Our market research solutions are based on robust data collection and analysis techniques, providing you with reliable insights that support strategic planning and execution.",
    keyHeading4: "Competitive Intelligence:-",
    keyF_4:
      "Stay ahead of the competition. We closely monitor your competitors' activities, strengths, weaknesses, and market positioning to help you identify competitive threats and capitalize on areas of opportunity.",
    keyHeading5: "Consumer Understanding:-",
    keyF_5:
      "Connect with your target audience. We delve deep into consumer preferences, needs, and buying behaviors to help you better understand your target market and tailor your products or services to meet their demands effectively.",

    image: marketingReseach,
    background: "#FADBD8",
    getACall: "See More",
  },
  {
    slug: "business-strategy",
    name: "Business Strategy",
    description:
      "Revolutionize Your Business Strategy with SocioLoom's Expert Guidance! In today's dynamic marketplace, having a robust business strategy is not just advantageous – it's essential. At SocioLoom, we specialize in crafting transformative business strategies that propel your organization towards sustained growth, competitive advantage, and long-term success.",
    shortDescription:
      "At SocioLoom, we craft bespoke business strategies tailored for success. From web development to digital marketing and brand building, our holistic approach aligns with your vision. We leverage innovation, collaboration, and budget-friendly solutions to propel your business forward. Choose SocioLoom as your strategic partner, where every idea meets a roadmap to triumph in the digital realm.",

    keyHeading1: "Strategic Analysis:-",
    keyF_1:
      "One size does not fit all. Our seasoned strategists conduct thorough analyses of your industry, market trends, competitors, and internal capabilities to develop bespoke strategies tailored to your unique needs.",
    keyHeading2: "Innovative Solutions:-",
    keyF_2:
      "Break away from the ordinary. We believe in thinking outside the box and delivering innovative solutions that disrupt the status quo, unlocking new opportunities and driving exponential growth.",
    keyHeading3: "Agile Implementation:-",
    keyF_3:
      "Speed is the name of the game. Our agile approach to strategy implementation ensures swift execution, allowing you to capitalize on emerging opportunities and stay ahead of the curve.",
    keyHeading4: "Performance Metrics:-",
    keyF_4:
      "Measure what matters. We establish clear, measurable performance metrics to track the effectiveness of your business strategy, enabling data-driven decision-making and continuous improvement.",
    keyHeading5: "Adaptive Planning:-",
    keyF_5:
      "Stay nimble in a rapidly changing environment. Our adaptive planning processes allow for flexibility and agility, ensuring that your business strategy remains relevant and responsive to evolving market dynamics.",

    image: businessStrategyImg,
    background: "#AED6F1",
    getACall: "See More",
  },
  {
    slug: "it-solutions",
    name: "IT Solutions",
    description:
      "Unlock Your Business Potential with SocioLoom's Cutting-Edge IT Solutions! In today's fast-paced digital world, having the right IT solutions is crucial for staying ahead of the competition. At SocioLoom, we offer a comprehensive suite of IT solutions designed to streamline your operations, enhance efficiency, and drive innovation.",
    shortDescription:
      "Empower your business with SocioLoom's comprehensive IT solutions. From seamless infrastructure management to cutting-edge cybersecurity, we deliver tailored strategies that align with your goals. Our innovative approach ensures scalability, efficiency, and robust technology integration. Choose SocioLoom for reliable IT solutions that propel your business into the future with confidence.",

    keyHeading1: "Strategic Planning:-",
    keyF_1:
      "We understand that every business is unique. Our IT solutions are tailored to your specific needs, ensuring that we address your challenges and capitalize on opportunities effectively.",
    keyHeading2: "Customized Solutions:-",
    keyF_2:
      "From software development to infrastructure management, our team of experts crafts bespoke IT solutions that align perfectly with your business goals and objectives.",
    keyHeading3: "Agile Implementation:-",
    keyF_3:
      "Speed is the name of the game. Our agile approach to strategy implementation ensures swift execution, allowing you to capitalize on emerging opportunities and stay ahead of the curve.",
    keyHeading4: "Scalable Architecture:-",
    keyF_4:
      "Our IT solutions are built with scalability in mind, allowing your systems to grow and adapt as your business evolves. Whether you're a startup or an enterprise, we've got you covered.",
    keyHeading5: "Security and Compliance:-",
    keyF_5:
      "Protecting your data is our top priority. Our IT solutions incorporate robust security measures and ensure compliance with industry standards to safeguard your sensitive information.",

    image: ItServiceImg,
    background: "#A2D9CE",
    getACall: "See More",
  },
];

const testimonialData = [
  {
    name: "Harsh Patel",
    desc: "SocioLoom transformed our digital landscape! Their web development expertise gave our brand a fresh online presence, and the digital marketing strategies elevated our reach. The collaborative approach and affordable solutions truly set them apart. Highly recommended for startups looking to make a mark!",
    img: harsh,
  },
  {
    name: "Emily Viz",
    desc: "SocioLoom's digital marketing prowess worked wonders for our boutique. Their strategies boosted our online visibility, and the creative content engaged our audience. The team's dedication to understanding our brand and industry made the collaboration seamless. SocioLoom is our go-to for all things digital!",
    img: Emily,
  },
  {
    name: "Abhinav Singh",
    desc: "Incredible IT solutions from SocioLoom! They revamped our infrastructure, enhancing efficiency and security. Their commitment to innovation and scalability aligned perfectly with our growing needs. SocioLoom has been a valuable partner in our tech journey.",
    img: abhinav,
  },
  {
    name: "Rehmat Khan",
    desc: "SocioLoom played a crucial role in optimizing our business processes. The customized web development solutions and efficient IT services streamlined our operations. The team's expertise and prompt support make them an indispensable part of our success.",
    img: rehmat,
  },
  {
    name: "Jason Harris",
    desc: "SocioLoom's web development services gave our online store a modern and user-friendly makeover. Their attention to detail and commitment to delivering quality exceeded our expectations. A reliable partner for any business looking to enhance its digital presence!",
    img: Jason,
  },
];

const countryCodes = [
  { value: "+1", label: "United State" },
  { value: "+7", label: "Russia" },
  { value: "+20", label: "Egypt" },
  { value: "+27", label: "South Africa" },
  { value: "+30", label: "Greece" },
  { value: "+31", label: "Netherlands" },
  { value: "+32", label: "Belgium" },
  { value: "+33", label: "France" },
  { value: "+34", label: "Spain" },
  { value: "+36", label: "Hungary" },
  { value: "+39", label: "Italy" },
  { value: "+40", label: "Romania" },
  { value: "+41", label: "Switzerland" },
  { value: "+43", label: "Austria" },
  { value: "+44", label: "United Kingdom" },
  { value: "+45", label: "Denmark" },
  { value: "+46", label: "Sweden" },
  { value: "+47", label: "Norway" },
  { value: "+48", label: "Poland" },
  { value: "+49", label: "Germany" },
  { value: "+51", label: "Peru" },
  { value: "+52", label: "Mexico" },
  { value: "+53", label: "Cuba" },
  { value: "+54", label: "Argentina" },
  { value: "+55", label: "Brazil" },
  { value: "+56", label: "Chile" },
  { value: "+57", label: "Colombia" },
  { value: "+58", label: "Venezuela" },
  { value: "+60", label: "Malaysia" },
  { value: "+61", label: "Australia" },
  { value: "+62", label: "Indonesia" },
  { value: "+63", label: "Philippines" },
  { value: "+64", label: "New Zealand" },
  { value: "+65", label: "Singapore" },
  { value: "+66", label: "Thailand" },
  { value: "+81", label: "Japan" },
  { value: "+82", label: "South Korea" },
  { value: "+84", label: "Vietnam" },
  { value: "+86", label: "China" },
  { value: "+90", label: "Turkey" },
  { value: "+92", label: "Pakistan" },
  { value: "+93", label: "Afghanistan" },
  { value: "+94", label: "Sri Lanka" },
  { value: "+95", label: "Myanmar" },
  { value: "+98", label: "Iran" },
  { value: "+91", label: "India" },
  { value: "+211", label: "South Sudan" },
  { value: "+212", label: "Morocco" },
  { value: "+213", label: "Algeria" },
  { value: "+216", label: "Tunisia" },
  { value: "+218", label: "Libya" },
  { value: "+220", label: "Gambia" },
  { value: "+221", label: "Senegal" },
  { value: "+222", label: "Mauritania" },
  { value: "+223", label: "Mali" },
  { value: "+224", label: "Guinea" },
  { value: "+225", label: "Ivory Coast" },
  { value: "+226", label: "Burkina Faso" },
  { value: "+227", label: "Niger" },
  { value: "+228", label: "Togo" },
  { value: "+229", label: "Benin" },
  { value: "+230", label: "Mauritius" },
  { value: "+231", label: "Liberia" },
  { value: "+232", label: "Sierra Leone" },
  { value: "+233", label: "Ghana" },
  { value: "+234", label: "Nigeria" },
  { value: "+235", label: "Chad" },
  { value: "+236", label: "Central African Republic" },
  { value: "+237", label: "Cameroon" },
  { value: "+238", label: "Cape Verde" },
  { value: "+239", label: "Sao Tome and Principe" },
  { value: "+240", label: "Equatorial Guinea" },
  { value: "+241", label: "Gabon" },
  { value: "+242", label: "Republic of the Congo" },
  { value: "+243", label: "Democratic Republic of the Congo" },
  { value: "+244", label: "Angola" },
  { value: "+245", label: "Guinea-Bissau" },
  { value: "+246", label: "British Indian Ocean Territory" },
  { value: "+247", label: "Ascension Island" },
  { value: "+248", label: "Seychelles" },
  { value: "+250", label: "Rwanda" },
  { value: "+249", label: "Sudan" },
  { value: "+251", label: "Ethiopia" },
  { value: "+252", label: "Somalia" },
  { value: "+253", label: "Djibouti" },
  { value: "+254", label: "Kenya" },
  { value: "+255", label: "Tanzania" },
  { value: "+256", label: "Uganda" },
  { value: "+257", label: "Burundi" },
  { value: "+258", label: "Mozambique" },
  { value: "+260", label: "Zambia" },
  { value: "+261", label: "Madagascar" },
  { value: "+262", label: "Reunion" },
  { value: "+263", label: "Zimbabwe" },
  { value: "+264", label: "Namibia" },
  { value: "+265", label: "Malawi" },
  { value: "+266", label: "Lesotho" },
  { value: "+267", label: "Botswana" },
  { value: "+268", label: "Eswatini" },
  { value: "+269", label: "Comoros" },
  { value: "+290", label: "Saint Helena" },
  { value: "+291", label: "Eritrea" },
  { value: "+297", label: "Aruba" },
  { value: "+298", label: "Faroe Islands" },
  { value: "+299", label: "Greenland" },
  { value: "+350", label: "Gibraltar" },
  { value: "+351", label: "Portugal" },
  { value: "+352", label: "Luxembourg" },
  { value: "+353", label: "Ireland" },
  { value: "+354", label: "Iceland" },
  { value: "+355", label: "Albania" },
  { value: "+356", label: "Malta" },
  { value: "+357", label: "Cyprus" },
  { value: "+358", label: "Finland" },
  { value: "+359", label: "Bulgaria" },
  { value: "+370", label: "Lithuania" },
  { value: "+371", label: "Latvia" },
  { value: "+372", label: "Estonia" },
  { value: "+373", label: "Moldova" },
  { value: "+374", label: "Armenia" },
  { value: "+375", label: "Belarus" },
  { value: "+376", label: "Andorra" },
  { value: "+377", label: "Monaco" },
  { value: "+378", label: "San Marino" },
  { value: "+380", label: "Ukraine" },
  { value: "+381", label: "Serbia" },
  { value: "+382", label: "Montenegro" },
  { value: "+383", label: "Kosovo" },
  { value: "+385", label: "Croatia" },
  { value: "+386", label: "Slovenia" },
  { value: "+387", label: "Bosnia and Herzegovina" },
  { value: "+389", label: "North Macedonia" },
  { value: "+420", label: "Czech Republic" },
  { value: "+421", label: "Slovakia" },
  { value: "+423", label: "Liechtenstein" },
  { value: "+500", label: "Falkland Islands" },
  { value: "+501", label: "Belize" },
  { value: "+502", label: "Guatemala" },
  { value: "+503", label: "El Salvador" },
  { value: "+504", label: "Honduras" },
  { value: "+505", label: "Nicaragua" },
  { value: "+506", label: "Costa Rica" },
  { value: "+507", label: "Panama" },
  { value: "+508", label: "Saint Pierre and Miquelon" },
  { value: "+509", label: "Haiti" },
  { value: "+590", label: "Guadeloupe" },
  { value: "+591", label: "Bolivia" },
  { value: "+592", label: "Guyana" },
  { value: "+593", label: "Ecuador" },
  { value: "+594", label: "French Guiana" },
  { value: "+595", label: "Paraguay" },
  { value: "+596", label: "Martinique" },
  { value: "+597", label: "Suriname" },
  { value: "+598", label: "Uruguay" },
  { value: "+599", label: "Caribbean Netherlands" },
  { value: "+670", label: "East Timor" },
  { value: "+672", label: "Norfolk Island" },
  { value: "+673", label: "Brunei" },
  { value: "+674", label: "Nauru" },
  { value: "+675", label: "Papua New Guinea" },
  { value: "+676", label: "Tonga" },
  { value: "+677", label: "Solomon Islands" },
  { value: "+678", label: "Vanuatu" },
  { value: "+679", label: "Fiji" },
  { value: "+680", label: "Palau" },
  { value: "+681", label: "Wallis and Futuna" },
  { value: "+682", label: "Cook Islands" },
  { value: "+683", label: "Niue" },
  { value: "+685", label: "Samoa" },
  { value: "+686", label: "Kiribati" },
  { value: "+687", label: "New Caledonia" },
  { value: "+688", label: "Tuvalu" },
  { value: "+689", label: "French Polynesia" },
  { value: "+690", label: "Tokelau" },
  { value: "+691", label: "Federated States of Micronesia" },
  { value: "+692", label: "Marshall Islands" },
  { value: "+850", label: "North Korea" },
  { value: "+852", label: "Hong Kong" },
  { value: "+853", label: "Macau" },
  { value: "+855", label: "Cambodia" },
  { value: "+856", label: "Laos" },
  { value: "+880", label: "Bangladesh" },
  { value: "+886", label: "Taiwan" },
  { value: "+960", label: "Maldives" },
  { value: "+961", label: "Lebanon" },
  { value: "+962", label: "Jordan" },
  { value: "+963", label: "Syria" },
  { value: "+964", label: "Iraq" },
  { value: "+965", label: "Kuwait" },
  { value: "+966", label: "Saudi Arabia" },
  { value: "+967", label: "Yemen" },
  { value: "+968", label: "Oman" },
  { value: "+970", label: "Palestine" },
  { value: "+971", label: "United Arab Emirates" },
  { value: "+972", label: "Israel" },
  { value: "+973", label: "Bahrain" },
  { value: "+974", label: "Qatar" },
  { value: "+975", label: "Bhutan" },
  { value: "+976", label: "Mongolia" },
  { value: "+977", label: "Nepal" },
  { value: "+992", label: "Tajikistan" },
  { value: "+993", label: "Turkmenistan" },
  { value: "+994", label: "Azerbaijan" },
  { value: "+995", label: "Georgia" },
  { value: "+996", label: "Kyrgyzstan" },
  { value: "+998", label: "Uzbekistan" },
];
export { service, testimonialData, countryCodes };
